import { useSelector } from 'react-redux';
import { Manager } from '../interfaces/types';
import { RootState } from '@cp/src/store';
import { Roles } from '@cp/src/pages/auth/constants/AuthConstants';

const NAVI_EMAIL_ID_REGEX = /^[A-Za-z0-9._%+-]+@navi\.com$/i;
const EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;

export const validateEmail = (value: string, naviUser?: boolean) => {
  if (naviUser && !NAVI_EMAIL_ID_REGEX.test(value)) {
    return false;
  }
  if (!EMAIL_VALIDATION_REGEX.test(value)) {
    return false;
  }
  return true;
};

export const convertToDropdownOptions = (list: Array<string>) => {
  return list.map(item => {
    return { label: item, value: item };
  });
};

export const convertToDropdownOptionsTitleCase = (list: Array<string>) => {
  return list.map(item => {
    return {
      label: capitalizeFirstLetterOfEachWord(item),
      value: capitalizeFirstLetterOfEachWord(item)
    };
  });
};

export const convertStringToDropdownOptionTitleCase = (str: string) => ({
  label: capitalizeFirstLetterOfEachWord(str),
  value: capitalizeFirstLetterOfEachWord(str)
});

export const convertStringToDropdownOption = (str: string) => ({
  label: str,
  value: str
});

export const transformManagers = (managers: Manager[]): any[] => {
  return managers.map(manager => ({
    value: manager.emailAddress,
    label: `${manager.name}  (${manager.emailAddress})`,
    additionalData: manager
  }));
};

export const transformedRegion = (regions: Region[]): IOption[] => {
  return regions.map(region => ({
    label: region?.displayableRegionText,
    value: region?.region,
    additionalData: {
      state: region?.states
    }
  }));
};

export const capitalizeFirstLetter = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const capitalizeFirstLetterOfEachWord = (str: string) => {
  if (!str) return '';
  return str
    .trim()
    .split(' ')
    .map(word =>
      word?.length > 0 ? word[0]?.toUpperCase() + word.substring(1).toLowerCase() : word
    )
    .join(' ');
};

export const useAuthentication = () => {
  const user = useSelector((state: RootState) => state.common.userData);

  const rolesContainAnyOfV1 = (roles: Array<string>) => {
    if (roles.indexOf('*') >= 0) {
      return true;
    }
    for (const role of roles) {
      if (user.roles && user.roles.includes(role)) {
        return true;
      }
    }
    return false;
  };

  return { rolesContainAnyOfV1 };
};

export const checkRolesForShowingPan = (
  rolesAvailable: string[],
  isNaviAgencySelected: boolean
) => {
  const isOnlyCallingAgentRoleSelected =
    rolesAvailable.length === 1 && rolesAvailable[0] === Roles.ROLE_CALLING_AGENT;

  const isNsaAgent =
    rolesAvailable.includes(Roles.ROLE_EXTERNAL_CSA) &&
    rolesAvailable.includes(Roles.ROLE_CALLING_AGENT);

  const isOmaAgent = rolesAvailable.includes(Roles.ROLE_OMA);
  const isAgencyTeamLead =
    rolesAvailable.includes(Roles.ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD) ||
    rolesAvailable.includes(Roles.ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD) ||
    rolesAvailable.includes(Roles.ROLE_NAVI_16_30_FIELD_TEAM_LEAD);

  const isPanDetailsRequired =
    (isOnlyCallingAgentRoleSelected && !isNaviAgencySelected) ||
    isNsaAgent ||
    isOmaAgent ||
    isAgencyTeamLead;

  return isPanDetailsRequired;
};
